module.exports = __webpack_public_path__ + "img/setblack.82cd9dc5.png";